export default __webpack_public_path__ + "static/media/news-s.7ad774c5.jpg";